import React from 'react';
import { STORE_LOCATIONS } from '../services/storeHoursApiService.ts';
import { getStoresGroupedByState } from '../utils/storeMapping.ts';
import StoreStatsTable from './StoreStatsTable.tsx';
import './AdminDashboard.css';

interface AdminDashboardProps {
  onSelectDocument: (docId: string, displayName: string) => void;
  onSelectStoreHours: (storeId: string, storeName: string) => void;
  onSelectMenuAudit: (retailerId: string, legacyMenuId: string, storeName: string, menuType: string) => void;
  onSelectCartMessage: () => void;
  onSelectHomeCollections: (storeName: string, menuType: string, displayName: string, retailerId: string, legacyMenuId: string) => void;
}

const AdminDashboard: React.FC<AdminDashboardProps> = ({ onSelectDocument, onSelectStoreHours, onSelectMenuAudit, onSelectCartMessage, onSelectHomeCollections }) => {
  const storesByState = getStoresGroupedByState();
  
  return (
    <div className="admin-dashboard">
      <h2>Admin Portal</h2>
      
      {/* Menu Statistics */}
      {false && <StoreStatsTable />}
      
      <div className="admin-sections">
        <div className="admin-section">
          <h3>Deals Management</h3>
          <div className="deals-by-state">
            {Object.entries(storesByState).map(([stateName, stores]) => (
              <div key={stateName} className="state-group">
                <h4>{stateName}</h4>
                <div className="document-options">
                  {stores.map((store) => (
                    <React.Fragment key={store.storeName}>
                      {store.medical && (
                        <button 
                          className="document-option-button"
                          onClick={() => onSelectDocument(
                            store.medical.legacyMenuId, 
                            `${store.displayName} MED (${store.medical.legacyMenuId})`
                          )}
                        >
                          <div className="option-title">{store.displayName} MED</div>
                          <div className="option-subtitle">Medical Cannabis Deals (Menu #{store.medical.legacyMenuId})</div>
                        </button>
                      )}
                      {store.recreational && (
                        <button 
                          className="document-option-button"
                          onClick={() => onSelectDocument(
                            store.recreational.legacyMenuId, 
                            `${store.displayName} REC (${store.recreational.legacyMenuId})`
                          )}
                        >
                          <div className="option-title">{store.displayName} REC</div>
                          <div className="option-subtitle">Recreational Cannabis Deals (Menu #{store.recreational.legacyMenuId})</div>
                        </button>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="admin-section">
          <h3>Store Hours Management</h3>
          <div className="document-options store-hours-grid">
            {STORE_LOCATIONS.map((store) => (
              <button
                key={store.id}
                className="document-option-button"
                onClick={() => onSelectStoreHours(store.id, store.name)}
              >
                <div className="option-title">{store.name.split(',')[0].trim().toUpperCase()}</div>
                <div className="option-subtitle">Store Hours</div>
              </button>
            ))}
          </div>
        </div>

        <div className="admin-section">
          <h3>Cart Message</h3>
          <p className="section-description">Configure the global cart message shown to customers</p>
          <div className="document-options">
            <button
              className="document-option-button cart-message-button"
              onClick={onSelectCartMessage}
            >
              <div className="option-title">Cart Message Settings</div>
              <div className="option-subtitle">Configure message, mode, and store targeting</div>
            </button>
          </div>
        </div>

        <div className="admin-section">
          <h3>Home Collections</h3>
          <div className="deals-by-state">
            {Object.entries(storesByState).map(([stateName, stores]) => (
              <div key={stateName} className="state-group">
                <h4>{stateName}</h4>
                <div className="document-options">
                  {stores.map((store) => (
                    <React.Fragment key={store.storeName}>
                      {store.medical && (
                        <button
                          className="document-option-button"
                          onClick={() => onSelectHomeCollections(
                            store.storeName,
                            'med',
                            `${store.displayName} MED`,
                            store.medical.menuId,
                            store.medical.legacyMenuId
                          )}
                        >
                          <div className="option-title">{store.displayName} MED</div>
                          <div className="option-subtitle">Medical Home Collections</div>
                        </button>
                      )}
                      {store.recreational && (
                        <button
                          className="document-option-button"
                          onClick={() => onSelectHomeCollections(
                            store.storeName,
                            'rec',
                            `${store.displayName} REC`,
                            store.recreational.menuId,
                            store.recreational.legacyMenuId
                          )}
                        >
                          <div className="option-title">{store.displayName} REC</div>
                          <div className="option-subtitle">Recreational Home Collections</div>
                        </button>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="admin-section">
          <h3>Menu Audit</h3>
          <div className="deals-by-state">
            {Object.entries(storesByState).map(([stateName, stores]) => (
              <div key={stateName} className="state-group">
                <h4>{stateName}</h4>
                <div className="document-options">
                  {stores.map((store) => (
                    <React.Fragment key={store.storeName}>
                      {store.medical && (
                        <button
                          className="document-option-button"
                          onClick={() => onSelectMenuAudit(
                            store.medical.menuId,
                            store.medical.legacyMenuId,
                            `${store.displayName} MED`,
                            'Medical'
                          )}
                        >
                          <div className="option-title">{store.displayName} MED</div>
                          <div className="option-subtitle">Medical Menu Audit</div>
                        </button>
                      )}
                      {store.recreational && (
                        <button
                          className="document-option-button"
                          onClick={() => onSelectMenuAudit(
                            store.recreational.menuId,
                            store.recreational.legacyMenuId,
                            `${store.displayName} REC`,
                            'Recreational'
                          )}
                        >
                          <div className="option-title">{store.displayName} REC</div>
                          <div className="option-subtitle">Recreational Menu Audit</div>
                        </button>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;